import { isNotLimited } from "PFApp/booking/components/booking_form/booking_form.utils";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { BookingDataItem, BookingFormMode } from "./booking_form.types";
import { BookingFormValues } from "./booking_form_values.types";
import { useGetCategoryErrorMessage } from "./use_category_error";

const getCategoryErrorPath = (index: number) => `bookings.${index}.category` as keyof BookingFormValues;

export const useValidateBookingsCategory = (mode: BookingFormMode): void => {
  const { setError, clearErrors } = useFormContext<BookingFormValues>();
  const getCategoryErrorMessage = useGetCategoryErrorMessage();

  const [bookings, activityId] = useWatch<BookingFormValues, ["bookings", "activityId"]>({
    name: ["bookings", "activityId"]
  });

  useEffect(() => {
    if (mode === BookingFormMode.EditAll || mode === BookingFormMode.Create) {
      return;
    }

    const bookingsList: BookingDataItem[] = bookings ?? [];

    bookingsList.forEach((booking, index) => {
      const path = getCategoryErrorPath(index);

      if (!isNotLimited(booking)) {
        clearErrors(path);
        return;
      }

      if (!booking.category) {
        setError(path, { type: "required" });
        return;
      }

      const message = getCategoryErrorMessage({ category: booking.category, isDemandRelated: !!activityId });
      if (message) {
        setError(path, { type: "validate", message });
      } else {
        clearErrors(path);
      }
    });
  }, [bookings, activityId, mode, setError, clearErrors, getCategoryErrorMessage]);
};
